import z from "zod/v4";
import {
  agentFomoPhone,
  americanAgentFomoPhone,
  berlinUsersGroupLink,
  israelUsersGroupLink,
  nycUsersGroupLink,
} from "../constants.ts";

export const country = z.enum(["Israel", "Germany", "USA"]);

export type Country = z.infer<typeof country>;

export const supportedCountries: Country[] = [...country.options];

export const countryDetails: Record<
  Country,
  {
    cities: string[];
    timezone: string;
    isoCode: string;
    currencySymbol: string;
    flag: string;
    usersGroupLink: string;
  }
> = {
  Israel: {
    cities: [],
    timezone: "Asia/Jerusalem",
    isoCode: "IL",
    currencySymbol: "₪",
    flag: "🇮🇱",
    usersGroupLink: israelUsersGroupLink,
  },
  Germany: {
    cities: ["Berlin"],
    timezone: "Europe/Berlin",
    isoCode: "DE",
    currencySymbol: "€",
    flag: "🇩🇪",
    usersGroupLink: berlinUsersGroupLink,
  },
  USA: {
    cities: ["NYC"],
    timezone: "America/New_York",
    isoCode: "US",
    currencySymbol: "$",
    flag: "🇺🇸",
    usersGroupLink: nycUsersGroupLink,
  },
};

export const chatPhoneForCountry = (country: Country | string): string =>
  country === "Israel" ? agentFomoPhone : americanAgentFomoPhone;

export const chatWhatsappLinkForCountry = (country: Country | string): string =>
  `https://wa.me/${chatPhoneForCountry(country)}`;

export const usersGroupLinkForCountry = (
  country: Country | string | undefined,
): string =>
  country === "Germany"
    ? berlinUsersGroupLink
    : country === "USA"
    ? nycUsersGroupLink
    : israelUsersGroupLink;

export const usersGroupLinkForCity = (
  city: string | undefined,
): string | undefined => {
  if (!city) return undefined;
  const lower = city.toLowerCase().trim();
  return lower === "berlin" || lower === "ברלין"
    ? berlinUsersGroupLink
    : lower === "nyc" || lower === "new york" || lower === "new york city" ||
        lower === "ניו יורק"
    ? nycUsersGroupLink
    : undefined;
};

export const currencySymbolForCountry = (country?: string): string => {
  const found = Object.entries(countryDetails).find(([name]) =>
    name === country
  );
  return found ? found[1].currencySymbol : "₪";
};
